<footer class="footer text-center text-sm-start d-print-none">
  <div class="container-xxl">
    <div class="row">
      <div class="col-12">
        <div class="card mb-0 rounded-bottom-0">
          <div class="card-body">
            <p class="text-muted mb-0">
              © {{ currentYear }} Temus
              <!-- <span class="text-muted d-none d-sm-inline-block float-end">
                Crafted with
                <i class="iconoir-heart text-danger"></i>
                by {{credits.name}}</span> -->
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
